//@ts-nocheck
import { createContext } from "react";

const CustomContext = createContext<any>();

export default CustomContext;
